module.exports = __webpack_public_path__ + "img/success.dc79fa57.svg";